/* 不是可選武將的單位：小兵、弓手、黃巾賊、中立首領呂布，以及造型（關羽的換裝）。 */
import { SG } from '../core/sg.ts';
import { H } from './define.ts';
import type { HeroSpec } from './types.ts';
import guan from './shu/guanyu.ts';

const soldier = (faction: string, name: string, armor: string, cloth: string, plume: string) => ({
  id: faction + '-soldier', name, faction, wclass: 'spear', weapon: 'spear', skin: '#eec79c', hair: '#1c1a1a', eye: 'round', head: 'cap', beard: null, fx: '#efe6d2', skill: null,
  c: { armor, sleeve: cloth, cloth, trim: '#b8a060', pants: '#2a2c2c', boot: '#2b2420', cape: null, belt: '#5a3a22', metal: '#8e979f', plume, pole: '#6b5238' },
});
SG.SOLDIERS = {
  shu: soldier('shu', '蜀兵', '#3e7b50', '#2f5e3f', '#46935c'),
  wu: soldier('wu', '吳兵', '#a93a30', '#7f2a24', '#d05a3a'),
  wei: soldier('wei', '魏兵', '#35518c', '#26335f', '#4f86e0'),
};

const archer = (sol: ReturnType<typeof soldier>, name: string) => Object.assign({}, sol, { id: sol.id.replace('soldier', 'archer'), name, weapon: 'bow', wclass: 'bow', ranged: true, c: Object.assign({}, sol.c, { pole: '#6b4a2a' }) });
SG.ARCHERS = { shu: archer(SG.SOLDIERS.shu, '蜀弓手'), wu: archer(SG.SOLDIERS.wu, '吳弓手'), wei: archer(SG.SOLDIERS.wei, '魏弓手') };
// 野區：黃巾軍（v0.3.10）。黃巾賊是粗布短打、綁黃頭巾的農民兵；渠帥是營地首領，黃頭巾、黃披風、雙斧
const yellow = (name: string, cloth: string, armor: string, extra: Record<string, unknown>, c: Record<string, unknown>) => {
  const b = soldier('neutral', name, armor, cloth, '#f2c230');
  return Object.assign(b, { head: 'headband' }, extra, { c: Object.assign(b.c, { band: '#f2c230', trim: '#d9a82a', metal: '#7e8379', belt: '#6a4a26', pants: '#4a3f30', boot: '#3a2e22' }, c) });
};
SG.NEUTRAL = {
  huangjin: yellow('黃巾賊', '#8c7650', '#a08a5c', { id: 'huangjin', skin: '#e2b88a' }, { sleeve: '#7a6644', pole: '#6b5238' }),
  bandit: yellow('黃巾渠帥', '#6a5530', '#b8902a', { id: 'bandit', weapon: 'twin', wclass: 'twin', bulk: 1.15, skin: '#c8905e', beard: 'bushy', eye: 'fierce' }, { cape: '#e0b02a', sleeve: '#5a4626', pole: '#4a3b30' }),
};
SG.LUBU = H('lubu', '呂布', '字奉先', 'neutral', '戰士', 'halberd', {
  weaponName: '方天畫戟', horns: true, eye: 'fierce', bulk: 1.2, size: 1.25, fx: '#ff5a3a',
  c: { armor: '#8a2a22', sleeve: '#5a1a16', cloth: '#3a1a16', trim: '#e0b64e', pants: '#2a1a16', boot: '#1a1414', cape: '#b3322a', belt: '#e0b64e', metal: '#e0b64e', plume: '#ff5a3a', pole: '#2a1a16' },
}, [
  ['無雙亂舞', 'spin', '旋戟橫掃周圍，每圈 {120/120/120/120} 傷害。'],
  ['方天畫戟', 'crescent', '揮出戟氣，造成 {220/220/220/220} 傷害。'],
  ['飛將', 'charge', '衝撞造成 {180/180/180/180} 傷害。'],
  ['天下無雙', 'slam', '躍起重砸，造成 {320/320/320} 傷害並擊飛。'],
]);

function variant(base: HeroSpec, over: Partial<HeroSpec>) {
  const v = Object.assign({}, base, over, { c: Object.assign({}, base.c, over.c || {}) });
  delete v._anims; delete v._ghost;
  return v;
}
SG.variant = variant;
SG.SKINS = [
  { label: '綠袍美髯', tier: '基本', note: '預設造型', spec: guan },
  {
    label: '武聖金甲', tier: '傳說', note: '換頭盔、甲色、刀桿、特效色',
    spec: variant(guan, { head: 'helmet', c: { armor: '#d2a93e', sleeve: '#8f2a22', cloth: '#8f2a22', cape: '#b3322a', metal: '#e0b64e', plume: '#b3322a', trim: '#f3dc8a', pole: '#5a2a1e', hood: '#b3322a', boot: '#3a2418', pants: '#3d2620' }, fx: '#ffd46b' }),
  },
  {
    label: '單騎夜行', tier: '史詩', note: '只換配色與特效色',
    spec: variant(guan, { c: { armor: '#2c2c36', sleeve: '#1f1f27', cloth: '#1d1d25', cape: '#4e1f2c', hood: '#3a3a48', trim: '#8fd8ff', pole: '#1b1b22', belt: '#3a2030' }, fx: '#7fe0ff' }),
  },
];
